import { render, staticRenderFns } from "./ProjectCardBadge.vue?vue&type=template&id=160bb4ba&scoped=true&"
import script from "./ProjectCardBadge.vue?vue&type=script&lang=ts&"
export * from "./ProjectCardBadge.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectCardBadge.vue?vue&type=style&index=0&id=160bb4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160bb4ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VFlex,VLayout})
